// src/client/hooks/useLoan.ts
import { useQuery } from '@tanstack/react-query';
import { loanService } from '@client/services';
import { ServiceError } from '@client/lib/serviceError';

export function useActiveLoan() {
  return useQuery({
    queryKey: ['client', 'loans', 'active'],
    queryFn: async () => {
      const r = await loanService.getActiveLoan();
      if (!r.ok) throw new ServiceError(r.error);
      return r.value;
    },
  });
}

export function useLoansHistory() {
  return useQuery({
    queryKey: ['client', 'loans', 'history'],
    queryFn: async () => {
      const r = await loanService.getLoansHistory();
      if (!r.ok) throw new ServiceError(r.error);
      return r.value;
    },
  });
}
